import { useContext } from 'react';
import { UserContext } from "./UserContext";
export var useUserContext = function useUserContext() {
  var context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUserContext must be used within a UserContextProvider');
  }
  return context;
};